import { Modal } from '@/components/utils/Modal';
import { conversationService } from '@/services/conversationService';
import type { ConversationDetail } from '@/types/conversation';
import { useState } from 'react';
import { useToast } from '@/components/ui/Toast';

type DeleteConversationModelProps = {
  open: boolean;
  setOpen: () => void;
  conversations: ConversationDetail[];
  SocketConnectionId?: string;
  deleteConversationFunction: () => void;
  onDeletedConversation: () => void;
};

const DeleteConversationModel = ({
  open,
  setOpen,
  conversations,
  SocketConnectionId,
  deleteConversationFunction,
  onDeletedConversation,
}: DeleteConversationModelProps) =>
{
  const [loading, setLoading] = useState(false);
  const { success } = useToast();

  const deleteConversation = async () =>
  {
    if (loading) return;
    setLoading(true);
    const dashboardGroupConvs = conversations.map(conv =>
    {
      return {
        DashboardGroupId: conv.DashboardGroupId,
        ConversationId: conv.ConversationId,
        ConfigValueId: conv.ConfigValueId,
      };
    });

    await conversationService.deleteConversation(0, dashboardGroupConvs, SocketConnectionId || '');
    deleteConversationFunction();
    const count = conversations.length;
    success(`${count} item${count !== 1 ? 's' : ''} deleted`);
    onDeletedConversation();
    close();
  };

  const close = () =>
  {
    setOpen();
    setLoading(false);
  };

  return (
    <Modal open={open} onClose={() => close()} title="Delete Item">
      <p className="pt-[10px] pb-[8px] px-[20px] text-sm w-128">
        Are you sure you want to delete this item across all dashboards? Once deleted, this item
        will remain in the Recycle Bin for 6 months and then be permanently deleted.
      </p>
      <div className="pt-3 text-right gap-[10px] relative overflow-hidden min-h-6 flex flex-row-reverse">
        <button
          type="button"
          disabled={loading}
          onClick={() =>
          {
            deleteConversation();
          }}
          className="bg-corgee-blue hover:bg-corgee-BlueHover border text-white text-xs h-7 px-3 py-1"
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => close()}
          className="bg-brightGray hover:bg-corgee-brightGrayHover border text-white text-xs h-7 px-3 py-1"
        >
          No
        </button>
      </div>
    </Modal>
  );
};

export default DeleteConversationModel;
